import { Injectable } from '@angular/core';
import { CustomIdTypeDetailsFragment, GetCustomIdTypesGQL } from 'generated/graphql';
import { cloneDeep } from 'lodash-es';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})

export class GetCustomIdTypesService {
  constructor(
    private _getCustomIdTypesGQL: GetCustomIdTypesGQL
  ) { }

  getCustomIdTypes(includeInactive: boolean = false): Observable<CustomIdTypeDetailsFragment[]> {
    return this._getCustomIdTypesGQL.fetch().pipe(
      map(({ data }) => {
        const types = cloneDeep(data.getCustomIdTypes);
        if (includeInactive) {
          return types;
        }
        return types.filter(type => type.active);
      }),
      map((types) => types.sort((a, b) =>
        a.label.toLocaleLowerCase().localeCompare(b.label.toLocaleLowerCase()))
      )
    );
  }
}
